export class AuthMissingError extends Error {
  request: any

  constructor(message: string, request?: any) {
    super(message)
    Object.setPrototypeOf(this, new.target.prototype)
    this.name = 'AuthMissingError'
    this.request = request
  }
}
